// Generated by ReScript, PLEASE EDIT WITH CARE


var defaultTimeZone_timeZones = [];

var defaultTimeZone = {
  country_code: "",
  country_name: "",
  phone_number_code: "",
  timeZones: defaultTimeZone_timeZones
};

export {
  defaultTimeZone ,
}
/* No side effect */
